import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { IStatisticsLabel } from "./interfaces";
import { EStatisticsTab } from "../domain/enums";

@Component({
    selector: "statistics-container",
    templateUrl: "./statistics-container.component.html",
    styleUrls: ["./statistics-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatisticsContainerComponent implements OnChanges {
    @ViewChild("scrollContainer", { static: true, read: ElementRef }) scrollContainer: ElementRef<any> = { nativeElement: undefined };
    @Input() statisticsLabels: IStatisticsLabel[] = [];
    @Input() category: EStatisticsTab | undefined = undefined;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["category"]?.currentValue) {
            this.scrollContainer.nativeElement.scrollTop = 0;
        }
    }
}
